import SubpageLayout from "@/components/SubpageLayout";
import {
  Map,
  CalendarClock,
  UserCog,
  FileCheck2,
  Route,
  AlertCircle,
  Timer,
  Wallet,
  KeyRound,
} from "lucide-react";

export default function HundrastningPage() {
  return (
    <div data-testid="page-hundrastning">
      <SubpageLayout
        category="Hundrastning & Schema"
        seoTitle="Hundrastning & Schema"
        seoDescription="Smart schemaläggning, live GPS-spårning och automatiska pass-rapporter för hundvakts­företag. Driv en professionell hundrastnings­tjänst utan WhatsApp-kaos."
        seoPath="/hundrastning-program"
        heroBadge="Hundrastning & Schema"
        title="Schemalägg teamet, spåra rutterna,"
        highlightWord="få rapporterna klara."
        subtitle="Hundifys hundrastnings-program ger dig allt du behöver för att driva en professionell promenadtjänst: smart schemaläggning av personalen, live GPS-spår av varje promenad och färdiga pass-rapporter som genereras automatiskt när skiftet är slut."
        heroImage="https://images.pexels.com/photos/38034768/pexels-photo-38034768.jpeg"
        ctaSource="Hundrastning Program"
        problem={{
          title: "Personal-schema och rapportering är där hundvakts-företag fastnar.",
          paragraphs: [
            "Det är inte själva promenaderna som är problemet. Det är allt runt omkring: vem går vart, när, med vilka hundar, med vilka nycklar. Vem är sjuk och vem täcker upp. Vem rapporterar vad — och hur vet kunden att hunden faktiskt fått sin timme?",
            "Med en växande verksamhet räcker det inte med en grupp-chat och en delad Google-kalender. Du behöver veta i realtid var dina anställda är, hur långt de gått, om de glömt ett pass och om en kund klagat. Och du behöver kunna visa kunden ett tydligt kvitto — varje gång.",
            "Hundify är byggt för det. Schemaläggning baserat på personalens tillgänglighet och kompetens, live GPS som ägaren själv kan följa, och automatiska pass-rapporter med rutt, distans, tid och anteckningar.",
          ],
        }}
        workflow={{
          title: "Från bokning till färdig pass-rapport.",
          intro:
            "Ett tight arbetsflöde som höjer professionalismen och ger dina kunder exakt det de förväntar sig av en premium-tjänst.",
          steps: [
            {
              title: "1. Smart schemaläggning",
              desc: "Systemet matchar varje promenad mot rätt hundvakt baserat på område, kompetens, tillgänglighet och nycklar.",
            },
            {
              title: "2. Skifts-start på telefonen",
              desc: "Hundvakten klockar in via appen. Dagens rutter, hundprofiler och portkoder dyker upp automatiskt.",
            },
            {
              title: "3. Live GPS-spårning",
              desc: "Ägaren kan följa promenaden live i sin app. Du som chef ser var hela teamet befinner sig — i realtid.",
            },
            {
              title: "4. Automatisk pass-rapport",
              desc: "När hunden är hemma genereras rapporten: rutt, distans, tid, bilder och anteckningar — skickas direkt till ägaren.",
            },
          ],
        }}
        stats={[
          { value: "100%", label: "Promenader med GPS-spår" },
          { value: "32 min", label: "Snittpromenad" },
          { value: "0", label: "Missade pass senaste kvartalet" },
        ]}
        features={[
          {
            icon: CalendarClock,
            title: "Personal-schema",
            desc: "Drag-and-drop schemaläggning. Anställda lägger in sin tillgänglighet, systemet föreslår optimal fördelning.",
          },
          {
            icon: UserCog,
            title: "Roller & behörigheter",
            desc: "Hundvakt, områdesansvarig, admin. Var och en ser bara det de behöver — inget mer.",
          },
          {
            icon: Map,
            title: "Live GPS-spårning",
            desc: "Realtids-spår på karta. Ägaren följer i sin app, du följer hela teamet i admin-vyn.",
          },
          {
            icon: Route,
            title: "Rutt-historik",
            desc: "Varje promenad sparas. Använd för försäkringsärenden, kvalitetskontroll och kundtjänst.",
          },
          {
            icon: FileCheck2,
            title: "Automatiska pass-rapporter",
            desc: "Rapport med karta, distans, tid, bilder och fri text — genereras och skickas automatiskt.",
          },
          {
            icon: KeyRound,
            title: "Nyckel- & portkods-register",
            desc: "Krypterad lagring av portkoder och nyckel-IDs. Bara behöriga ser dem, och bara vid aktivt pass.",
          },
          {
            icon: Timer,
            title: "Klocka in & ut",
            desc: "Arbetstid loggas automatiskt per pass. Underlag för löneutbetalning utan handpåläggning.",
          },
          {
            icon: AlertCircle,
            title: "Incident-rapportering",
            desc: "Bråk med annan hund, lös koppling, halt underlag — incidenter loggas direkt och flaggas till chef.",
          },
          {
            icon: Wallet,
            title: "Löner & ersättning",
            desc: "Arbetstid + km-ersättning + tillägg räknas ut automatiskt. Exportera till Fortnox, Visma eller Bokio.",
          },
        ]}
        faq={[
          {
            q: "Hur funkar GPS-spårningen — är den batteritjuvande?",
            a: "Vi använder energi-optimerad bakgrundspositionering. En 60-min promenad drar typiskt under 4% batteri på en modern telefon.",
          },
          {
            q: "Kan jag använda systemet för enstaka uppdrag, inte bara abonnemang?",
            a: "Absolut. Du sätter upp engångs-pass och abonnemangspaket parallellt. Faktureringen anpassas per kundtyp.",
          },
          {
            q: "Vad händer om en hundvakt missar ett pass?",
            a: "Systemet larmar dig automatiskt om incheckning inte sker inom planerad tid. Du kan reagera direkt och kontakta backup.",
          },
        ]}
      />
    </div>
  );
}
